var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.0021 1.95737C16.3927 1.56685 16.3927 0.933681 16.0021 0.543157C15.6116 0.152632 14.9785 0.152632 14.5879 0.543157L8.54541 6.58567L2.50289 0.543157C2.11237 0.152632 1.4792 0.152632 1.08868 0.543157C0.698155 0.933681 0.698155 1.56685 1.08868 1.95737L7.1312 7.99989L1.08862 14.0425C0.698093 14.433 0.698093 15.0662 1.08862 15.4567C1.47914 15.8472 2.11231 15.8472 2.50283 15.4567L8.54541 9.4141L14.588 15.4567C14.9785 15.8472 15.6117 15.8472 16.0022 15.4567C16.3927 15.0662 16.3927 14.433 16.0022 14.0425L9.95962 7.99989L16.0021 1.95737Z","fill":"#005598"}));
}

Close.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Close;

Close.default = Close;
